import {
  IDiagnosticOrder,
  IDocumentReference,
  IOrderedObject,
  ISpecimen,
  ITestConfiguration,
  IWorkflowRequest
} from '../interfaces/diagnostic-order.interface';
import {TestRunningMode} from "@ispm/test/interfaces/test-running-mode.enum";
import {AuthenticationService} from "@ispm/user/services/authentication.service";

/**
 * Created by 310293471 on 18/03/2018.
 */
export class DiagnosticOrder implements IDiagnosticOrder {
  status?: string;
  id: string;
  role: string;
  site: { code: string; display: string};
  reason: any[];
  orderBy: string;
  orderer: string;
  subject: string;
  priority: string;
  specimen: ISpecimen[];
  diagnosis: { code: string; display: string};
  performer: string;
  dateOfTest: string;
  recipients: { id: string; type: string}[];
  tumorStage: { code: string; system: string; display: string};
  identifiers: { value: string}[];
  imagingInfo: string;
  organization: string;
  managingFacility?: string;
  resourceType: string;
  ordererObject: IOrderedObject;
  histopathology: { code: string; display: string};
  treatmentStatus: { code: string; display: string};
  workflowRequest: IWorkflowRequest;
  testConfigurations: ITestConfiguration[];
  managingOrganization: string;
  orderingPractitioner: string;
  workflowRequestTemplateId: string;
  fullRecipientsObj: any[];
  mappedRecipients: string;
  performingPractitioner: string;
  orderByPractitioner: string;
  resultStatus?: string;
  localDateTime?: string;
  reportRef?: string;
  tumorPercent?: number;
  tumorWarning?: boolean;
  documentReferences?: IDocumentReference[];
  discipline?: any;
  disease?: any;
  runningMode?: TestRunningMode;
  notesContent?:any[];
  private static authService;

  constructor(subject: string, role: string, authService : AuthenticationService) {
    this.subject = subject;
    this.role = role;
  }

  /**
   * check if the user is the performer
   * if no user id is passes, active user is checked
   * @param {IDiagnosticOrder} diagnosticOrder
   * @param {string} userId - optional
   * @returns {boolean}
   */
  public static isAssignee(diagnosticOrder: IDiagnosticOrder, userId?: string): boolean {
    if (!userId) {
      userId = this.authService.user.info.id;
    }
    return userId === diagnosticOrder.performer;

  }

  public setOrganization(organization: string): DiagnosticOrder {
    this.organization = organization;
    return this;
  }

  public setManagingOrganization(managingOrganization: string): DiagnosticOrder {
    this.managingOrganization = managingOrganization;
    return this;
  }

  public setPerformer(performer: string): DiagnosticOrder {
    this.performer = performer;
    return this;
  }

  public setAdditionalData(additionalData: any) {
    Object.assign(this, additionalData );
    return this;
  }

}
